import { makeReducer } from "../../core/make-reducer";
import ViewerMethod from "../../core/ViewerMethod";

export default makeReducer(ViewerMethod.GET_PAGE_BREAKS);
